// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"284":"512247cf","333":"4d505888","431":"141b2333","786":"9c2d6dd1","995":"512247cf"}[chunkId] + ".chunk.css";
};